/**
 * The view context of the screen on display, attached to every `/api/call`
 * (as `viewContext`) and every maître d'AI question that does not bring its
 * own. OpsCommand sets it while rendering; the API layer only reads it, so
 * it never depends on screen code (docs/view-context.md).
 *
 * It never enters a request's cache key: methods compute from their
 * arguments, and the context only describes what the person is looking at.
 */
let current: unknown = null;

export function setRequestViewContext(context: unknown): void {
  current = context ?? null;
}

export function getRequestViewContext(): unknown {
  return current;
}
